import {DEFAULT_COL_WIDTH} from '../constants/defaultColWidth';

/**
 * Coerces an optional column width to an integer pixel value.
 *
 * The backend virtual-preset endpoint requires `columnsSettings[].width` to be
 * an integer. PointerEvent.clientX can be fractional on high-DPI displays, so
 * widths computed from resize deltas may end up as floats (e.g. 213.5).
 * This helper guarantees the value is always a whole number.
 */
export const toIntegerWidth = (width: number | undefined): number =>
  Math.round(width ?? DEFAULT_COL_WIDTH);
